import styled from 'styled-components';

export const Dot = styled.div<{ size: number; color: string; $mx?: number }>`
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  background-color: ${(p) => p.color};
  border-radius: 50%;
  margin-right: ${(p) => (!isNaN(p.$mx) ? p.$mx : 6)}px;
`;
